export default __webpack_public_path__ + "static/media/donationWidget-selected.e5d928a6.svg";